/* Relevant Variables from theme.liquid
    customerId
    customerAssignedStoreId (n2_id of assigned store in customer metafield: customer.metafields.custom.assignedStore default value is 'not set')
    storePageStoreId
 */

(async function ($) {
    const SELECTED_STORE_ID_COOKIE_STORAGE_KEY = "SELECTED_STORE_ID_COOKIE_STORAGE_KEY";
    const UTM_STORE_ID_PARAMETER_KEY = "utm_store_id";
    const SHOP_PERMANENT_DOMAIN = shopPermanentDomain;

    const LIVE_PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL = "https://reformhaus.n8n.dna.ax/webhook/6ff0b070-5aa7-49b0-bd67-d13af46ed0f5";

    const STAGE_PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL = "https://reformhaus.n8n.dna.ax/webhook/da5b7066-b0c8-404b-a935-8656adc35e13";

    let PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL = "";

    if(SHOP_PERMANENT_DOMAIN == "reformhausdigital.myshopify.com"){
        PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL = LIVE_PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL;
    } else {
        PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL = STAGE_PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL;
    }

    var storeIdUtmParameter = null,
        customerLoggedIn = !!customerId;

    function setCookie(name, value, expireDays) {
        const d = new Date();
        let expires = "";
        if (expireDays) {
            d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
            expires = "expires=" + d.toUTCString();
        }

        if(!value || value === "" || value === "not set") {
            expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }

        document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function setStoreIdCartAttribute(storeId) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                attributes: {
                    'Filial-ID': storeId
                }
            })
        });
    }

    function persistSelectedStoreInformationLocal(storeId) {
        setCookie(SELECTED_STORE_ID_COOKIE_STORAGE_KEY, storeId);
    }

    function persistSelectedStoreInformationGlobal(storeId) {
        if(customerLoggedIn){
            fetch(PERSIST_CUSTOMER_GLOBAL_WEBHOOK_URL, {
                method: "POST",
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                    storeId: storeId,
                    customerId: customerId
                })
            });
        }
    }

    async function getStoreIdByCookie(){
        var storeId = getCookie(SELECTED_STORE_ID_COOKIE_STORAGE_KEY);

        if (storeId) {
            return storeId;
        }

        return 'not set';
    }

    async function getStoreIdByCurrentStorePage() {
        if(storePageStoreId){
            return storePageStoreId;
        }

        return 'not set';
    }

    async function getStoreIdByUtmParameter() {
        const currentUrl = window.location.href;
        const queryString = currentUrl.split("?");
        if (queryString.length > 1) {
            const queryPart = queryString[1].split("&");
            for (let i in queryPart) {
                const value = queryPart[i].split("=");

                if (value[0] === UTM_STORE_ID_PARAMETER_KEY) {
                    storeIdUtmParameter = value[1]
                }
            }
        }

        if (storeIdUtmParameter) {
            return storeIdUtmParameter;
        }

        return 'not set';
    }

    async function getAssignedStoreId() {
        var utmStoreId = await getStoreIdByUtmParameter();

        if (utmStoreId !== 'not set') {
            return utmStoreId;
        }

        var pageStoreId = await getStoreIdByCurrentStorePage();
        if (pageStoreId !== 'not set') {
            return pageStoreId;
        }

        if (customerAssignedStoreId !== 'not set') {
            return customerAssignedStoreId;
        }

        var cookieStoreId = await getStoreIdByCookie();
        return cookieStoreId;
    }

    async function setAssignedStore(storeId) {
        persistSelectedStoreInformationLocal(storeId);

        if(storeId !== customerAssignedStoreId){
            persistSelectedStoreInformationGlobal(storeId)
        }

        setStoreIdCartAttribute(storeId);
    }

    var assignedStoreId = await getAssignedStoreId();
    await setAssignedStore(assignedStoreId);

})(jQuery);
